import { httpGet } from '../../data'

const listsURL = '/list'

// could maybe combine this into one function
// these right are return a list of strings
// but might return a list of objects {id: string, name: string}
// type List = string | {id: string, name: string}
export interface IListItem {
  id: string
  name: string
}

export async function getTitles() {
  return await httpGet<string[] | IListItem[]>(`${listsURL}/titles`, true)
}

export async function getTrades() {
  return await httpGet<string[] | IListItem[]>(`${listsURL}/trades`, true)
}
